/**
 * Section impression names for /wedding-planning.
 *
 * Same reasoning as `wedding-photo-sharing/sections.js` and
 * `digital-wedding-invitation/sections.js`: `trackSectionViewed` is
 * section-name-agnostic, but the shared analytics module documents its
 * supported values as a closed set with a named wrapper per value, and that
 * module is vendored byte-identical into invite/ and app/ (guarded by
 * `npm run verify:analytics`). Page-local constants keep the "one owner per
 * string, never a literal at a call site" rule without editing two other apps
 * to instrument a landing-page section.
 *
 * Six impressions, not eleven — the same restraint the sibling pages exercise.
 * The money question, the differentiator, the offer, the plan qualifier, the
 * questions and the close. Enough to see where a search visitor stops without
 * turning the funnel report into noise; the eight editorial sections in between
 * are one continuous argument and splitting them would measure scroll depth,
 * not interest.
 */
export const WPL_SECTION = {
  BUDGET: "wedding_planning_budget",
  EROS: "wedding_planning_eros",
  DEMO: "wedding_planning_demo",
  PLAN: "wedding_planning_plan",
  FAQ: "wedding_planning_faq",
  FINAL_CTA: "wedding_planning_final_cta",
};

export default WPL_SECTION;
